import type { CurrencyCodeType } from '@mint-lib/currencies-helpers';
import { useTranslation } from '@mint-lib/i18n';

import { useUpdateMediaPlanRowMutation } from '../api/mediaPlansApiSlice.js';
import type { ErrorObject } from '../types/shared.js';
import { extractMessageFromError } from '../utils/helpers.js';
import useSimpleNotification from './useSImpleNotification.js';

export const useMediaPlanRowUpdate = () => {
  const { t } = useTranslation('@myn/planning');

  const [updateMediaPlanRow, { isLoading: isMediaPlanRowUpdating }] =
    useUpdateMediaPlanRowMutation();

  const { showErrorNotification } = useSimpleNotification();

  const onUpdateRowError = (error: ErrorObject): void => {
    const message = extractMessageFromError(error.data, t);

    showErrorNotification({
      title: t('Error'),
      subTitle: message,
    });
  };

  const updateRow = async (
    rowId: number,
    currency: CurrencyCodeType | null,
  ) => {
    const result = await updateMediaPlanRow({
      rowId,
      overriddenCurrency: currency,
    });

    if ('error' in result) {
      onUpdateRowError(result.error as ErrorObject);
    }
  };

  return {
    updateRow,
    isLoading: isMediaPlanRowUpdating,
  };
};
